import React, { useState, useEffect, useRef, Suspense } from 'react';
import Game from '../../../../class/Game/Game';
import Games from '../../../../class/Game_copy/Game';
import { openGameModal } from '../../modal/modal_game';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import LoadingGif from './loading_game.gif';
import 'slick-carousel/slick/slick-theme.css';
import { useTranslation } from 'react-i18next';

import ModalLogin from '../../modal/modal_login.js';


import LOAD_GAMES_BY_PROVIDER_ID from '../../modal/load_games_by_provider_id';

const cmsUrl = process.env.REACT_APP_CMS_URL_ASSETS;

const ProviderGames = ({ provider, user_id, cetegory, AuthService, isLogged, setIsLoginModalOpen }) => {
  const { t } = useTranslation();
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const sliderRef = useRef(null); // Створюємо посилання на слайдер



  const [selectedProvider, setSelectedProvider] = useState(null);
  const [showGamesModalSingleProvider, setshowGamesModalSingleProvider] = useState(false);

  const [customclss, setCustomClass] = useState('');

  const openSingleProvidersModal = (provider) => {
    setSelectedProvider(provider);
    setshowGamesModalSingleProvider(true);
  };

  const closeGamesModal = () => { 
    setSelectedProvider(null);
    setshowGamesModalSingleProvider(false);
  };


  const updateFavoriteGame = async (newGameId ) => {
    if (isLogged) {
      try {
        // Получаем инфу об игре
        const gameInfo = await Games.getGameInfo(newGameId);
        const gameType = gameInfo?.params?.game_info[0]?.category_slug || '';

        const user_id = await AuthService.getCustom('user_id');
        const lastGames = await Games.updateFavoriteGames(user_id, gameType, newGameId );
        
        // console.log("NUOVO GIOCO PREFERITO");
        // console.log(lastGames);

      } catch (error) {
        console.error('Failed to fetch game info or open game:', error);
      }
    } else if (!isLogged) {
      setIsLoginModalOpen(true);
      console.error(t('User_is_not_logged_in.'));
    }

    // console.log('ModalGame opened with gameId:', [newGameId, isLogged]);
  };

  useEffect(() => {

    const fetchGames = async () => {
      try {

        const gamesData = await Games.getProviderGame(user_id, provider.id, 20, 1, cetegory);   // limit, page, category_slug, category_id

        // const gamesData = await Game.getProviderGame(user_id, provider.id, 20, 1, cetegory);

        // console.log(gamesData)
       
        setGames(gamesData.params.games);

      

       
       
        setLoading(false);
      } catch (error) {
        console.error('Error fetching games:', error);
        setLoading(false);
      }
    };

    fetchGames();
  }, [provider.id, user_id, cetegory]);

  const getProviderIcon = (providerslug) => {
    return `${cmsUrl}static-assets/providers/${providerslug}.png`;
  };
  
  const slidesToShow = 6;
  const isSliderInfinite = games.length > slidesToShow;


  useEffect(() => {
    if (games.length === 1) {
      setCustomClass('single'); // Якщо одна гра
    } else {
      setCustomClass('multiple'); // Якщо більше однієї
    }
  }, [games]);

  const renderLoadingGames = () => {
    return Array.from({ length: 10 }).map((_, index) => (
      <div key={index} className="HomeSectionCasinoGames_game">
        <div className="CasinoGameCard_root">
          <div className="CasinoGamePreview_root blurred">
            <div className="CasinoGamePreview_gradient"></div>
            <img
              className="ResponsivePicture_img CasinoGamePreview_image"
              src={LoadingGif}
              style={{ filter: 'blur(10px)' }}
              alt="Loading..."
            />
            <button>
              <img className="ResponsivePicture_img CasinoGamePreview_image"
              src='/assets/img/icon-btn/suggested.svg'
              style={{ filter: 'blur(10px)' }}
              alt="Loading..."/>
            </button>
          </div>
          <div className="CasinoGameCard_info CasinoGameCard_withProvider">
            <div className="CasinoGameCard_icon_placeholder"></div>
            <p className="CasinoGameCard_name_placeholder" style={{ filter: 'blur(10px)' }}>{t('loading')}...</p>
          </div>
        </div>
      </div>
    ));
  };

  const settings = {
    dots: false,
    infinite: isSliderInfinite,
    speed: 800,
    slidesToShow,
    slidesToScroll: 3,
    ref: sliderRef, // Передаємо посилання на слайдер
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
    <div className={`slide-general-game ${customclss}`}>
      <div className="body main-layout-item">
        <div className="Home_root">
          <div className="Home_games">
            <div className="Home_header">
              <a  className="HomeSection_header" onClick={() => openSingleProvidersModal(provider)}>
                <img
                  alt={provider.name || 'Provider'}
                  src={getProviderIcon(provider.slug)}
                  className="HomeSection_icon"
                />
                <div className="HomeSection_label" onClick={() => openSingleProvidersModal(provider)}>{provider.name}</div>
                <div className="HomeSection_right">
                  <div className="HomeSection_headerLink" onClick={() => openSingleProvidersModal(provider)}> {t('All')}</div>
                  <div className="HomeSection_caption">{provider.active_games || 0} {t('Games')}</div>
                  

                </div>
                
              </a>
              
            </div>

            <div className="justify-content-center multi-slider-box">
              {loading ? (
                  <Slider {...settings}>{renderLoadingGames()}</Slider>
                // <p>{t('Loading')}...</p>
              ) : games.length === 1 ? (
                <>

                  {customclss === 'multiple' && (
                    <div className="multi-slider carousel slide">
                      <button className="carousel-control-prev w-aut" role="button" onClick={() => sliderRef.current.slickPrev()}>
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                      </button>
                      <button className="carousel-control-next w-aut" role="button" onClick={() => sliderRef.current.slickNext()}>
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                      </button>
                    </div>
                  )}
                  <Slider {...settings} ref={sliderRef}>
                
                    <div key={games[0].id} className="HomeSectionCasinoGames_game" >
                      <div className="CasinoGameCard_root">
                        <div className="CasinoGamePreview_root" onClick={() => openGameModal(games[0].id)}>
                          <img className="ResponsivePicture_img CasinoGamePreview_image" src={games[0].thumbnail || 'default-image.jpg'} alt={games[0].name} loading="lazy" />
                        </div>
                        <div className="CasinoGameCard_info CasinoGameCard_withProvider">
                          <div className="CasinoGameCard_provider">
                            <img alt={provider.name} src={getProviderIcon(provider.slug)} className="CasinoGameCard_icon" onClick={() => openGameModal(games[0].id)}/>
                            <p className="CasinoGameCard_name" onClick={() => openGameModal(games[0].id)}>{provider.name}</p>
                            <button style={{zIndex: "100", width: "12%", position: "absolute", height: "12%",left: "80%"}} onClick={
                              () => {
                                if(isLogged){
                                  updateFavoriteGame(games[0].id);
                                  setGames(prev =>
                                    prev.map(g =>
                                      g.id === games[0].id
                                        ? { ...g, favorite: Number(g.favorite) == 1 ? 0 : 1 }
                                        : g
                                    )
                                  );
                                } else{
                                  setIsLoginModalOpen(true);
                                }
                              }  
                            }>
                              <svg className="" viewBox='0 0 50 50'>
                                <path d="M38.7,8.9c-4.4-2.4-10.2-1.7-13.8,1.6c-3.7-3.3-9.4-4-13.9-1.6C7.2,11,4.8,15,4.8,19.4
                                  c0,1.2,0.2,2.5,0.6,3.5c1.9,8.6,18,18.8,18.7,19.2l0.8,0.5l0.8-0.5c0.7-0.4,16.7-10.6,18.6-19c0.4-1.2,0.6-2.4,0.6-3.7 
                                  C44.8,15,42.5,11,38.7,8.9z" fill={(Number(games[0].favorite) == 1) ? "red" : "transparent"} style={{ stroke: "red", strokeWidth: "4px" }}
                                />
                              </svg>

                            </button>
                          </div>
                          <p className="CasinoGameCard_gameName" title={games[0].name} onClick={() => openGameModal(games[0].id)}>{games[0].name}</p>
                        </div>
                      </div>
                    </div>
                  </Slider>
                </>

              ) : (
                /*** ✅ Відображення слайдера якщо більше 1 гри ***/
                <>
                  {customclss === 'multiple' && (
                    <div className="multi-slider carousel slide">
                      <button className="carousel-control-prev w-aut" role="button" onClick={() => sliderRef.current.slickPrev()}>
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                      </button>
                      <button className="carousel-control-next w-aut" role="button" onClick={() => sliderRef.current.slickNext()}>
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                      </button>
                    </div>
                  )}

                  <Slider {...settings} ref={sliderRef}>
                    {games.map((game) => {
                      return (
                        <div key={game.id} className="HomeSectionCasinoGames_game" /* onClick={() => openGameModal(game.id)} */>
                          <div className="CasinoGameCard_root">
                            <div className="CasinoGamePreview_root" onClick={() => openGameModal(game.id)}>
                              <img className="ResponsivePicture_img CasinoGamePreview_image" src={game.thumbnail || 'default-image.jpg'} alt={game.name} loading="lazy" />
                            </div>
                            <div className="CasinoGameCard_info CasinoGameCard_withProvider" /* onClick={() => openGameModal(game.id)} */>
                              <div className="CasinoGameCard_provider">
                                <img alt={provider.name} src={getProviderIcon(provider.slug)} className="CasinoGameCard_icon" onClick={() => openGameModal(game.id)}/>
                                <p className="CasinoGameCard_name" onClick={() => openGameModal(game.id)}>{provider.name}</p>
                                <button style={{zIndex: "100", width: "12%", position: "absolute", height: "12%",left: "80%"}} onClick={
                                  () => {
                                    if(isLogged){
                                      updateFavoriteGame(game.id);
                                      setGames(prev =>
                                        prev.map(g =>
                                          g.id === game.id
                                            ? { ...g, favorite: Number(g.favorite) == 1 ? 0 : 1 }
                                            : g
                                        )
                                      );
                                    } else{
                                      setIsLoginModalOpen(true);
                                    }
                                  }  
                                }>
                                  <svg className="" viewBox='0 0 50 50'>
                                    <path d="M38.7,8.9c-4.4-2.4-10.2-1.7-13.8,1.6c-3.7-3.3-9.4-4-13.9-1.6C7.2,11,4.8,15,4.8,19.4
                                      c0,1.2,0.2,2.5,0.6,3.5c1.9,8.6,18,18.8,18.7,19.2l0.8,0.5l0.8-0.5c0.7-0.4,16.7-10.6,18.6-19c0.4-1.2,0.6-2.4,0.6-3.7 
                                      C44.8,15,42.5,11,38.7,8.9z" fill={(Number(game.favorite) == 1) ? "red" : "transparent"} style={{ stroke: "red", strokeWidth: "4px" }}
                                    />
                                  </svg>

                                </button>
                              </div>
                              <p className="CasinoGameCard_gameName" title={game.name} onClick={() => openGameModal(game.id)}>{game.name}</p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </>
              )}
            </div>
          </div>
        
     
        </div>
      </div>
      
  
    </div>

    {showGamesModalSingleProvider && (
      <LOAD_GAMES_BY_PROVIDER_ID
        Game={Games}
        AuthService={AuthService}
        user_id={AuthService.getCustom('user_id') || ''}
        provider_id={selectedProvider?.id}
        category_id={selectedProvider?.category_id}
        provider_name={selectedProvider?.name}
        provider_slug={selectedProvider?.slug}
        onClose={closeGamesModal}
        isLogged={isLogged}
        setIsLoginModalOpen={setIsLoginModalOpen}
      />
    )}

</>
  );
};

export default ProviderGames;
